import React from 'react'
import './App.css'
import AppProviders from './app/providers'

function App() {
  return <AppProviders />
}

export default App
